<div class="site-section" >
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-5">
        <div class="login-content">
        </div>

        <!-- Login Form -->
        <div *ngIf="isShowLoginForm && !isForgetFormShow">
          <h2 class="formhead mt-4">{{"TOPNAV.SIGN_IN" |
            translate}}</h2>
          <form [formGroup]="loginForm" class="formshadow mb-4">
            <div class="row">
              <div class="col-md-12 form-group">
                <label for="userName"> {{'SIGNUPPAGE.MOBILE' | translate}}</label>
                <input autocomplete="off" type="text" name="name" placeholder="{{'SIGNUPPAGE.MOBILE' | translate}}"
                  formControlName="userName" class="form-control form-control-lg" />
                <div class="container-err" *ngIf="submitted && f.userName.errors">
                  <div *ngIf="submitted && f.userName.errors.required" class="error-msg-lbl errormsg">
                    {{"SIGNINPAGE.ERROR.MOBILE_REQUIRED" | translate}}
                  </div>
                  <div *ngIf="submitted && f.userName.errors.pattern" class="error-msg-lbl">
                    {{"CONTACTUS.ERROR.ENTER_VALID_NUMBER" | translate}}
                  </div>
                </div>
              </div>
              <div class="col-md-12 form-group">
                <label for="pword">{{'SIGNUPPAGE.PASSWORD' | translate}}</label>
                <input type="password" name="password" [type]="hide ? 'password' : 'text'" maxlength="100" placeholder="{{'SIGNUPPAGE.PASSWORD' | translate}}"
                  class="form-control form-control-lg" formControlName="password"/>
                  <span class="btn-visible" id="logwith1237" name="logwith1237" *ngIf="!hide" (click)="showPassword()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 15">
                        <path fill="#5F6778" fill-rule="nonzero"
                            d="M11.996.046C7.412.046 3.256 2.554.188 6.628a.95.95 0 0 0 0 1.133c3.067 4.079 7.224 6.587 11.808 6.587s8.741-2.508 11.809-6.582a.95.95 0 0 0 0-1.134C20.737 2.554 16.58.046 11.996.046zm.33 12.186A5.05 5.05 0 0 1 6.96 6.868c.157-2.513 2.194-4.55 4.706-4.707a5.05 5.05 0 0 1 5.365 5.365c-.162 2.508-2.199 4.544-4.707 4.706zm-.153-2.326A2.713 2.713 0 0 1 9.287 7.02a2.729 2.729 0 0 1 2.538-2.537 2.713 2.713 0 0 1 2.885 2.886 2.729 2.729 0 0 1-2.537 2.537z" />
                    </svg>
                </span>
                <span class="btn-visible" id="logshowpass11" name="logshowpass11" *ngIf="hide" (click)="showPassword()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
                    <g fill="#5F6778" fill-rule="evenodd">
                        <path fill-rule="nonzero"
                            d="M11.996 3.046c-4.584 0-8.74 2.508-11.808 6.582a.95.95 0 0 0 0 1.133c3.067 4.079 7.224 6.587 11.808 6.587s8.741-2.508 11.809-6.582a.95.95 0 0 0 0-1.134c-3.068-4.078-7.225-6.586-11.809-6.586zm.33 12.186A5.05 5.05 0 0 1 6.96 9.868c.157-2.513 2.194-4.55 4.706-4.707a5.05 5.05 0 0 1 5.365 5.365c-.162 2.508-2.199 4.544-4.707 4.706zm-.153-2.326a2.713 2.713 0 0 1-2.886-2.886 2.729 2.729 0 0 1 2.538-2.537 2.713 2.713 0 0 1 2.885 2.886 2.729 2.729 0 0 1-2.537 2.537z" />
                        <path d="M20.132 0l1.414 1.414L3.868 19.092l-1.414-1.414z" />
                    </g>
                </svg>
                </span>
                <div class="container-err" *ngIf="submitted && f.password.errors">
                  <div *ngIf="submitted && f.password.errors.required" class="error-msg-lbl errormsg">
                    {{"SIGNUPPAGE.ERROR.PASSWORD_IS_REQUIRED" | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-4">
                <button type="submit" class="submit" (click)="onLoginFormSubmit()"
                  class="btn btn-primary px-5 mr-4">
                  {{"TOPNAV.SIGN_IN" |
                  translate}}
                </button>
                <button type="submit" class="submit" (click)="getOTPforLogin()"
                class="btn btn-primary px-5 m-2">
                {{"SIGNINPAGE.SIGN_OTP" | translate}}
              </button>
            </div><br><br>

            <p class="text-center">  {{"SIGNINPAGE.DONT_HV_ACCOUNT" | translate}}<span routerLink="/register" class="notmember"> {{"TOPNAV.SIGN_UP" | translate}}</span> </p>
            <p *ngIf="isShowLoginForm" (click)="isForgetFormShow = true" class="text-center"><span class="notmember">
              {{"SIGNINPAGE.FORGOT_PASSWORD" | translate}} </span></p>
          </form>

        </div>

        <!-- Forgot Password -->
        <div class="mb-4" *ngIf="isForgetFormShow">
          <h2 class="formhead mt-4">{{"SIGNINPAGE.FORGOT_PASSWORD" | translate}}</h2>
          <form class="login-form formshadow" [formGroup]="forgetOTPForm" autocomplete="off">
            <div class="forget-otp-wrapper" *ngIf="!isForgetOtpSent">
              <label for="userName">{{'SIGNUPPAGE.MOBILE' | translate}}</label>
              <input type="text" name="name" placeholder="{{'SIGNUPPAGE.MOBILE' | translate}}" autocomplete="off"
                class="form-control form-control-lg" formControlName="username" />
               <div class="text-center mt-4">
              <button type="submit" class="submit" class="btn btn-primary px-5 mr-4" style="color:white;"
                [ngClass]="!forgetOTPForm.controls['username'].valid ? 'disabled-color' : ''"
                [disabled]="!forgetOTPForm.controls['username'].valid"
                (click)="getOtpForForget()">{{"RESETPASSWORD.GET_OTP" | translate}}</button>
              </div>
            </div>

            <!-- Verify OTP -->
            <div class="new-password-wrapper" *ngIf="isForgetOtpSent">
              <div class="contact-number-item padding-20 mb-4 text-center">
                <form [formGroup]="OTPForm" class="varify-code-form" autocomplete="off">
                  <label for="">{{"SIGNINOTP.ENTER_CODE" | translate}}</label>
                  <div class="verify-otp-input justify-content-center align-items-center">
                    <input class="txt-otp" type="number" name="code" maxlength="1" id="forgetlogininput1"
                      formControlName="input1" (keyup)="focusForgetInputLogin($event, '1')" (input)="restrictInput($event)"  />
                    <input class="txt-otp" type="number" name="code" maxlength="1" id="forgetlogininput2"
                      formControlName="input2" (keyup)="focusForgetInputLogin($event, '2')" (input)="restrictInput($event)" />
                    <input class="txt-otp" type="number" name="code" maxlength="1" id="forgetlogininput3"
                      formControlName="input3" (keyup)="focusForgetInputLogin($event, '3')" (input)="restrictInput($event)" />
                    <input class="txt-otp" type="number" name="code" maxlength="1" id="forgetlogininput4"
                      formControlName="input4" (keyup)="focusForgetInputLogin($event, '4')" (input)="restrictInput($event)" />
                  </div>
                </form>
                <a class="resendadj" (click)="getOtpForForget()">{{"SIGNINOTP.RESEND_CODE" | translate}}</a>
              </div>

              <!-- New Password  -->
              <label for="">{{'RESETPASSWORD.NEW_PASSWORD' | translate}}</label>
              <div>
                <input name="name" maxlength="100" [type]="hide ? 'password' : 'text'" placeholder="{{'RESETPASSWORD.NEW_PASSWORD' | translate}}" formControlName="newPassword"
                  class="form-control form-control-lg" />
                  <span class="btn-visible" id="logwith1237" name="logwith1237" *ngIf="!hide" (click)="showPassword()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 15">
                        <path fill="#5F6778" fill-rule="nonzero"
                            d="M11.996.046C7.412.046 3.256 2.554.188 6.628a.95.95 0 0 0 0 1.133c3.067 4.079 7.224 6.587 11.808 6.587s8.741-2.508 11.809-6.582a.95.95 0 0 0 0-1.134C20.737 2.554 16.58.046 11.996.046zm.33 12.186A5.05 5.05 0 0 1 6.96 6.868c.157-2.513 2.194-4.55 4.706-4.707a5.05 5.05 0 0 1 5.365 5.365c-.162 2.508-2.199 4.544-4.707 4.706zm-.153-2.326A2.713 2.713 0 0 1 9.287 7.02a2.729 2.729 0 0 1 2.538-2.537 2.713 2.713 0 0 1 2.885 2.886 2.729 2.729 0 0 1-2.537 2.537z" />
                    </svg>
                </span>
                <span class="btn-visible" id="logshowpass11" name="logshowpass11" *ngIf="hide" (click)="showPassword()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
                    <g fill="#5F6778" fill-rule="evenodd">
                        <path fill-rule="nonzero"
                            d="M11.996 3.046c-4.584 0-8.74 2.508-11.808 6.582a.95.95 0 0 0 0 1.133c3.067 4.079 7.224 6.587 11.808 6.587s8.741-2.508 11.809-6.582a.95.95 0 0 0 0-1.134c-3.068-4.078-7.225-6.586-11.809-6.586zm.33 12.186A5.05 5.05 0 0 1 6.96 9.868c.157-2.513 2.194-4.55 4.706-4.707a5.05 5.05 0 0 1 5.365 5.365c-.162 2.508-2.199 4.544-4.707 4.706zm-.153-2.326a2.713 2.713 0 0 1-2.886-2.886 2.729 2.729 0 0 1 2.538-2.537 2.713 2.713 0 0 1 2.885 2.886 2.729 2.729 0 0 1-2.537 2.537z" />
                        <path d="M20.132 0l1.414 1.414L3.868 19.092l-1.414-1.414z" />
                    </g>
                </svg>
                </span>

                <div *ngIf="!fp.newPassword.valid && fp.newPassword.errors.pattern" class="error-msg-lbl errormsg">
                  {{"SIGNUPPAGE.ERROR.PASSWORD_IS_REQUIRED_VALIDATION" | translate}}
                  </div>
              </div><br>

              <!-- Reset Password -->
              <div class="text-center">
              <button [ngClass]="!forgetOTPForm.controls['newPassword'].valid ? 'disabled-color': ''" type="submit"
                class="btn btn-primary px-5 mr-4"
                [disabled]="!forgetOTPForm.controls['newPassword'].valid"
                (click)="setForgetPassword()">{{"RESETPASSWORD.RESET_PASSWORD" | translate}}</button>
              </div>
            </div>
          </form>
        </div>

        <!-- Login With OTP -->
        <div class="mb-4" *ngIf="!isShowLoginForm && showverifyOtpFormLogin">
          <h2 class="formhead mt-4"> {{"SIGNINPAGE.SIGN_OTP" | translate}}</h2>
          <form [formGroup]="OTPForm" class="varify-code-form formshadow text-center">
            <div class="verify-otp-input justify-content-center align-items-center">
              <input class="txt-otp" type="number" name="code" maxlength="1" id="logininput1" formControlName="input1"
                (keyup)="focusInputLogin($event, '1')"  (input)="restrictInput($event)" />
              <input class="txt-otp" type="number" name="code" maxlength="1" id="logininput2" formControlName="input2"
                (keyup)="focusInputLogin($event, '2')"  (input)="restrictInput($event)" />
              <input class="txt-otp" type="number" name="code"  maxlength="1"id="logininput3" formControlName="input3"
                (keyup)="focusInputLogin($event, '3')"  (input)="restrictInput($event)" />
              <input class="txt-otp" type="number" name="code"  maxlength="1"id="logininput4" formControlName="input4"
                (keyup)="focusInputLogin($event, '4')"  (input)="restrictInput($event)"/>
            </div>
            <br>
            <!-- <button [ngClass]="!OTPForm.controls['input3'].valid ? 'disabled-color': ''" type="submit"
            class="btn btn-primary px-5 mr-4"
            [disabled]="!OTPForm.controls['input3'].valid"
            (click)="resendOtp()">{{"SIGNINOTP.RESEND_CODE" | translate}}</button> -->

            <a class="resendadj" (click)="resendOtp()">{{"SIGNINOTP.RESEND_CODE" | translate}}</a><br>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>